var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 46,
    viewBox: "0 0 54 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5667 0C24.8512 0 23.1556 1.09075 21.8864 3.2524L1.10271 37.9976C-1.43575 42.311 0.547426 45.613 5.62435 45.613H47.509C52.8437 45.613 54.8864 42.0631 52.3479 37.9976L31.3263 3.2524C30.057 1.09075 28.2821 0 26.5667 0ZM26.7253 11.5817C27.9945 11.5817 28.7382 12.0874 29.5018 12.851C30.2653 13.6145 30.533 14.616 30.533 15.6274C30.533 16.6388 28.9762 24.0162 28.4705 29.351H24.6628C24.1571 24.0162 22.6796 16.6388 22.6796 15.6274C22.6796 14.616 23.1854 13.6145 23.9489 12.851C24.7124 12.0874 25.7139 11.5817 26.7253 11.5817ZM26.7253 31.6514C27.7367 31.6514 28.7382 31.9192 29.5018 32.6827C30.2653 33.4462 30.771 34.4477 30.771 35.4591C30.771 36.7284 30.2653 37.4721 29.5018 38.2356C28.7382 38.9991 27.7367 39.2668 26.7253 39.2668C25.7139 39.2668 24.7124 38.9991 23.9489 38.2356C23.1854 37.4721 22.6796 36.7284 22.6796 35.4591C22.6796 34.4477 23.1854 33.4462 23.9489 32.6827C24.7124 31.9192 25.7139 31.6514 26.7253 31.6514Z",
    fill: "#FFD250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.d9b87575d18c8fa870ed381b2485fa31.svg";
export { ForwardRef as ReactComponent };